module.exports = __webpack_public_path__ + "img/a240895.svg";